import {
  CreateOrderRequest,
  CurrentItem,
  CurrentPlan,
  ItemOffer,
  OrderForm,
  ReplacementOffer,
  Service,
  SortCode,
} from '@dgx-pr-spa/shared/util';

export class CreateOrderHelper {
  constructor(
    public currentPlan?: CurrentPlan,
    public currentItem?: CurrentItem,
    public replacementCost?: number,
    public selected?: ReplacementOffer,
    public isProtectionSelected?: boolean,
    public itemOffer?: ItemOffer,
    public extras?: Service[],
    public form?: OrderForm,
    public orderNumber?: string,
    public clientReferenceNumber?: string,
    public reuseDirectDebitDetails?: boolean,
    public directDebitPaymentToken?: string,
    public directDebitError?: boolean
  ) {}

  get itemOfferDetails() {
    const purchasePrice =
      this.selected?.rrp <= 0.01
        ? this.currentItem.purchase_price + this.selected.upgrade_fee
        : this.selected?.rrp;

    return {
      offer_upsell_flag: this.isProtectionSelected,
      item_offer_hash: this.itemOffer?.itemOfferHash,
      item_gid: this.itemOffer?.itemGid,
      offer_reference: this.itemOffer?.offerReference,
      item_code: this.selected?.item_code,
      manuf_code: this.selected?.manuf_code,
      warranty: this.selected?.warranty,
      purchase_price: purchasePrice,
      model: this.selected?.model,
      period_Of_cover: this.itemOffer?.periodOfCover,
      fee: this.itemOffer?.fee,
      paymentType: this.itemOffer?.paymentType,
      number_of_payments: this.itemOffer?.numberOfPayments,
      first_payment: this.itemOffer?.firstPayment,
      subsequent_payment: this.itemOffer?.subsequentPayment,
      ...(this.itemOffer?.itemUrn && { item_urn: this.itemOffer?.itemUrn }),
    };
  }

  get deliveryInstructions() {
    const addInfo = this.form?.delivery?.additionalInfo
      ? `Additional Info:\n${this.form.delivery.additionalInfo}\n\n `
      : '';
    const accessInfo = this.form?.delivery?.accessInfo
      ? `Access Info:\n${this.form.delivery.accessInfo}`
      : '';

    return `${addInfo}${accessInfo}`;
  }

  formatSortCode(sort: SortCode) {
    return sort ? `${sort.sort1}${sort.sort2}${sort.sort3}` : undefined;
  }

  buildSendDocsByPost() {
    return this.form?.directDebit
      ? {
          send_docs_by_post: this.form?.directDebit.postPolicy,
        }
      : {};
  }

  buildPaymentDetails() {
    const preferredPaymentDay =
      this.form?.directDebit?.preferredPaymentDay || '01';

    const sort = this.form?.directDebit?.sortCode;
    const sortCode =
      !!sort?.sort1 && !!sort?.sort2 && !!sort.sort3
        ? `${sort.sort1}${sort.sort2}${sort.sort3}`
        : '';

    const accountDetails = this.reuseDirectDebitDetails
      ? { payment_token: this.directDebitPaymentToken }
      : {
          branch_code: sortCode,
          account_number: this.form?.directDebit?.accountNumber,
        };

    return this.isProtectionSelected
      ? {
          dd_details: {
            name: this.form?.directDebit?.accountHolderName || '',
            nom_pay_day: preferredPaymentDay,
            ...accountDetails,
          },
        }
      : {};
  }
  get requestBody(): CreateOrderRequest {
    // Any is required for instance of check
    let date: any = this.form?.delivery?.expectedDate;

    if (date && date instanceof Date) {
      const month =
        (date as Date).getMonth() + 1 < 10
          ? `0${(date as Date).getMonth() + 1}`
          : (date as Date).getMonth() + 1;
      const year = (date as Date).getFullYear();
      const calendarDate =
        (date as Date).getDate() < 10
          ? `0${(date as Date).getDate()}`
          : (date as Date).getDate();
      date = `${year}-${month}-${calendarDate}`;
    }

    const newDate = date ? date.split('/').reverse().join('-') : '';
    const directDebitPayload = this.buildPaymentDetails();
    const sendDocsByPost = this.buildSendDocsByPost();
    const request = {
      request_source: 'BVUK',
      channel_code: '0035',
      channel_group_code: '0005',
      client_code: this.currentPlan?.client_code,
      client_group_code: this.currentPlan?.client_group_code,
      offer_reference: this.clientReferenceNumber,
      card_payment_details: {
        card_payment_flag: this.replacementCost ? true : false,
        client_reference_number: this.clientReferenceNumber,
        order_number: this.orderNumber,
        amount: this.replacementCost,
        upgrade: this.selected?.upgrade_fee,
        currency: 'GBP',
        company_code: this.currentPlan?.company_code,
        scheme_code: this.currentPlan?.scheme_code,
        reference_number: this.currentPlan?.reference_number,
      },
      item_offer_details: this.itemOfferDetails,
      ...directDebitPayload,
      pr_order_request: {
        offer_type: this.selected?.offer_type,
        supplier_id: this.selected?.supplier_id,
        cat_num: this.selected?.cat_num,
        delivery_date: newDate || 'Supplier to arrange',
        delivery_instructions: this.deliveryInstructions || 'N/A',
        is_access_an_issue:
          this.form?.delivery?.accessDifficulties === 'No' ? true : false,
        is_not_ground_floor:
          this.form?.delivery?.stairs === 'Yes' ? true : false,
        email_address: this.form?.delivery?.email,
        mobile_phone: this.form?.delivery?.mobile || '',
        daytime_phone:
          this.form?.delivery?.telephone || this.form?.delivery?.mobile,
        services: this.extras,
        ...sendDocsByPost,
      },
    };

    return request;
  }
}
